$(function() {
    'use strict';
    $(document).on('ready', function () {
        $('.vendor-tunnel__first-step').on('submit', function() {
            if ($(this).data('already-submited')) {
                return false;
            }
            $(this).data('already-submited', true);
        })
    });
});